import {
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR } from './types';

export default {

  [OPEN_SNACKBAR](state, content) {
    state.snackbar.message = content.message;
    state.snackbar.active = true;
  },

  [CLOSE_SNACKBAR](state) {
    state.snackbar.message = '';
    state.snackbar.actionText = '';
    state.snackbar.active = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/app/mutations.js